import { importScreen } from '@infrastructure/splitting';

const BriefingDetails = importScreen(() => import('./BriefingDetails'));

export { BriefingDetails };
